import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-condition',
  imports: [],
  templateUrl: './terms-condition.component.html',
  styleUrl: './terms-condition.component.scss'
})
export class TermsConditionComponent {

}
